import PropTypes from "prop-types";
import React, { memo } from "react";
import { AvatarImage, AvatarLetter, AvatarRoot } from "./elements";

export const BettoProfileAvatar = memo(({ letter, size = 72, showLetter = true }) => (
	<AvatarRoot
		$size={size}
		aria-hidden={showLetter && letter ? "true" : undefined}>
		{showLetter && letter ? (
			<AvatarLetter $size={size}>{letter}</AvatarLetter>
		) : (
			<AvatarImage
				src="/profile.svg"
				alt=""
			/>
		)}
	</AvatarRoot>
));

BettoProfileAvatar.displayName = "BettoProfileAvatar";

BettoProfileAvatar.propTypes = {
	letter: PropTypes.string,
	size: PropTypes.number,
	showLetter: PropTypes.bool,
};
